import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Container, Typography } from '@material-ui/core';

import { PORTFOLIO_PATH } from '../routes';

import CardWrapper from '../components/common/CardWrapper';

/* eslint-disable indent */
const Root = styled(Container)`
	text-align: center;

	h1 {
		margin: 40px 0;
		font-size: 48px;
	}

	a {
		margin: 0 0 40px 0;
		display: inline-block;
		padding: 10px 40px;
		background-color: ${(props) =>
			props.theme.palette.button.primary.backgroundColor};
		color: ${(props) => props.theme.palette.button.primary.color};
		font-size: 18px;
		border-radius: 50px;
		text-decoration: none;
		border: 2px solid ${(props) => props.theme.palette.button.primary.backgroundColor};

		&:hover {
			background-color: transparent;
			border: 2px solid ${(props) => props.theme.palette.button.primary.color};
		}
	}
`;

const Page404 = () => (
	<Root maxWidth="lg">
		<CardWrapper>
			<Typography variant="h1">
				404 - Seite konnte nicht gefunden werden.
			</Typography>
			<Link to={PORTFOLIO_PATH}>Zurück zur Startseite</Link>
		</CardWrapper>
	</Root>
);

export default Page404;
